import { render, staticRenderFns } from "./IndexOverviews.vue?vue&type=template&id=e473e074&"
import script from "./IndexOverviews.vue?vue&type=script&lang=js&"
export * from "./IndexOverviews.vue?vue&type=script&lang=js&"
import style0 from "./IndexOverviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports